module.exports = __webpack_public_path__ + "img/NOT_EQUAL.5f05b8db.svg";